import { useSelector } from "react-redux";
import useGetMediaLocation from "../hooks/useGetMediaLocation";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";

export default function ImageSequence({ cue, cloud }) {
    const { projectId } = useParams();
    const mediaLocation = useGetMediaLocation();

    const [currentImageIndex, setCurrentImageIndex] = useState(0);

	const media = useSelector((state) => state.main?.projects?.[projectId]?.media) || [];
    const mediaFiltered = media.filter((item)=>item.partOf === cue.filename)

    useEffect(() => {
        let intervalId;
    
        const nextImage = () => {
            // Calculate the next image index and ensure it does not exceed the length of imageFilenames
            setCurrentImageIndex(currentImageIndex + 1);
        };
    
        if (currentImageIndex !== parseInt(cue.stopAt)) {
          intervalId = setInterval(nextImage, 16);
        } else if (cue.status === 'going') {
            intervalId = setInterval(nextImage, 16);
        }
    
        // Clear the interval when the component unmounts, when it reaches the stopAt index,
        // or when cueStatus changes to something other than "going"
        return () => clearInterval(intervalId);
      }, [currentImageIndex, mediaFiltered.length, cue.stopAt, cue.status]);

      if(currentImageIndex >= mediaFiltered.length -1) return null
    return (
        <img className="w-screen h-screen image_key" src={`${mediaLocation}${cloud ? cue.url : mediaFiltered[currentImageIndex].filename}`} />
    );
}
